import React from 'react';

const DatenschutzPage: React.FC = () => {
  return (
    <div className="legal-page">
      <div className="container">
        <h1>Datenschutzerklärung</h1>

        <p><strong>Stand: 18. September 2026</strong></p>

        <p>
          Diese Datenschutzerklärung erläutert, welche personenbezogenen Daten beim Besuch dieser
          Website verarbeitet werden, zu welchen Zwecken dies geschieht und welche Rechte Ihnen
          zustehen.
        </p>

        <h2>1. Verantwortliche Stelle</h2>
        <p>
          Ayşegül Saraç<br />
          Remigiusstraße 39<br />
          50937 Köln
        </p>
        <p>
          Telefon: +49 (0) 152 2830 1212<br />
          E-Mail: <a href="mailto:info@aysegulsarac.com">info@aysegulsarac.com</a>
        </p>

        <h2>2. Zugriffsdaten und Hosting</h2>
        <p>
          Beim Aufruf dieser Website können durch den technischen Hosting-Betrieb vorübergehend
          Server-Log-Daten verarbeitet werden. Dazu können insbesondere IP-Adresse, Datum und Uhrzeit
          des Zugriffs, Browsertyp, Betriebssystem, Referrer-URL sowie die aufgerufene Seite gehören.
        </p>
        <p>
          Die Verarbeitung erfolgt zur sicheren Bereitstellung, Stabilität und Fehleranalyse der
          Website auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO.
        </p>

        <h2>3. Kontaktaufnahme</h2>
        <p>
          Wenn Sie per E-Mail oder telefonisch Kontakt aufnehmen, verarbeiten wir die von Ihnen
          übermittelten Angaben ausschließlich zur Bearbeitung Ihrer Anfrage und für mögliche
          Anschlussfragen.
        </p>
        <p>
          Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage auf den Abschluss oder
          die Durchführung eines Vertrages gerichtet ist, andernfalls Art. 6 Abs. 1 lit. f DSGVO.
        </p>

        <h2>4. Kontaktaufnahme und Terminanfrage über WhatsApp</h2>
        <p>
          Für Kontakt- und Terminanfragen verlinkt diese Website auf WhatsApp. WhatsApp wird nicht
          automatisch auf dieser Website geladen. Erst wenn Sie einen entsprechenden Link anklicken,
          verlassen Sie unsere Website und es öffnet sich WhatsApp bzw. die WhatsApp-Website. Dabei
          können durch WhatsApp technische Verbindungsdaten verarbeitet werden. Nachrichten, die Sie
          anschließend versenden, werden durch WhatsApp und durch uns zur Bearbeitung Ihrer Anfrage
          verarbeitet.
        </p>
        <p>
          Verantwortlicher Anbieter für Nutzerinnen und Nutzer im Europäischen Wirtschaftsraum ist
          WhatsApp Ireland Limited, Merrion Road, Dublin 4, D04 X2K5, Irland. Weitere Informationen
          finden Sie in der{' '}
          <a
            href="https://www.whatsapp.com/legal/privacy-policy-eea"
            target="_blank"
            rel="noopener noreferrer"
          >
            Datenschutzrichtlinie von WhatsApp
          </a>
          .
        </p>

        <h2>5. Cookies, Local Storage und Einwilligungsverwaltung</h2>
        <p>
          Diese Website verwendet ein Consent-Banner, um Ihre Auswahl zu optionalen Analyse-Cookies
          zu verwalten. Dabei werden lokal im Browser insbesondere die Werte{' '}
          <code>cookie_consent</code>, <code>cookie_analytics</code> und{' '}
          <code>cookie_consent_version</code> gespeichert.
        </p>
        <p>
          Diese Speicherung erfolgt, um Ihre Einwilligungsentscheidung zu dokumentieren und das Banner
          nicht bei jedem Aufruf erneut anzuzeigen. Sie ist für die technisch saubere Steuerung Ihrer
          Auswahl erforderlich. Rechtsgrundlage ist § 25 Abs. 2 Nr. 2 TDDDG sowie Art. 6 Abs. 1 lit. f
          DSGVO.
        </p>
        <p>
          Sie können Ihre Auswahl jederzeit über „Cookie-Einstellungen“ im unteren Bereich der Website
          ändern oder gespeicherte Einstellungen durch Löschen der Browserdaten entfernen. Ein Widerruf
          wirkt für die Zukunft und berührt nicht die Rechtmäßigkeit der bis dahin erfolgten Verarbeitung.
        </p>

        <h2>6. Google Analytics 4</h2>
        <p>
          Wenn Sie über das Consent-Banner ausdrücklich einwilligen, verwenden wir Google Analytics 4,
          einen Webanalysedienst der Google Ireland Limited, Gordon House, Barrow Street, Dublin 4,
          Irland. Die verwendete Mess-ID lautet <code>G-755Q5SLSNY</code>.
        </p>
        <p>
          Google Analytics hilft uns zu verstehen, welche Seiten besucht und welche wichtigen
          Verknüpfungen – beispielsweise zu unseren Leistungen, zur Terminseite oder zu WhatsApp –
          angeklickt werden. Dabei können insbesondere aufgerufene Seiten, Zeitpunkt und ungefähre
          Dauer des Besuchs, Referrer-URL, Geräte- und Browserinformationen, ungefähre geografische
          Angaben sowie Interaktionsereignisse verarbeitet werden. Wir übermitteln über die von uns
          eingerichteten Ereignisse keine von Ihnen in WhatsApp eingegebenen Nachrichten oder sonstigen
          bewusst eingegebenen Kontaktdaten an Google Analytics.
        </p>
        <p>
          Google Analytics wird auf dieser Website im „Basic Consent Mode“ eingesetzt: Vor Ihrer
          Einwilligung wird das Google-Analytics-Skript nicht geladen und es werden keine
          Analyseinformationen an Google übertragen. Werbung, Remarketing, Google Signals und
          personalisierte Anzeigen sind in unserer Einbindung deaktiviert.
        </p>
        <p>
          Rechtsgrundlage für das Speichern bzw. Auslesen von Analyseinformationen auf Ihrem Endgerät
          ist Ihre Einwilligung gemäß § 25 Abs. 1 TDDDG. Rechtsgrundlage für die anschließende
          Verarbeitung personenbezogener Daten ist Art. 6 Abs. 1 lit. a DSGVO. Sie können Ihre
          Einwilligung jederzeit über „Cookie-Einstellungen“ mit Wirkung für die Zukunft widerrufen.
          Bei einem Widerruf werden die für diese Website erreichbaren Google-Analytics-Cookies nach
          Möglichkeit gelöscht und weitere Messungen unterbunden.
        </p>
        <p>
          Google kann Daten auch auf Servern außerhalb der Europäischen Union bzw. des Europäischen
          Wirtschaftsraums verarbeiten. Google stützt solche Übermittlungen nach eigenen Angaben auf
          anwendbare Angemessenheitsbeschlüsse und geeignete Garantien. Weitere Informationen zur
          Datenverarbeitung durch Google finden Sie in der{' '}
          <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">
            Datenschutzerklärung von Google
          </a>{' '}
          sowie in den{' '}
          <a href="https://business.safety.google/adsprocessorterms/" target="_blank" rel="noopener noreferrer">
            Datenverarbeitungsbedingungen für Google Werbeprodukte
          </a>
          .
        </p>

        <h2>7. Externe Inhalte und externe Links</h2>
        <p>
          Auf dieser Website finden Sie Verlinkungen zu externen Plattformen und Diensten, darunter
          insbesondere YouTube, Instagram, LinkedIn, Google sowie WhatsApp. Beim Anklicken dieser
          Links verlassen Sie unsere Website. Für die Datenverarbeitung auf den jeweiligen Plattformen
          sind ausschließlich deren Betreiber verantwortlich.
        </p>
        <p>
          Bitte beachten Sie die Datenschutzhinweise der jeweiligen Anbieter, bevor Sie diese
          Angebote nutzen.
        </p>

        <h2>8. Speicherdauer</h2>
        <p>
          Personenbezogene Daten speichern wir nur so lange, wie dies für die Bearbeitung Ihrer
          Anfrage, zur Vertragserfüllung, zur Einhaltung gesetzlicher Pflichten oder zur Wahrung
          berechtigter Interessen erforderlich ist.
        </p>

        <h2>9. Ihre Rechte</h2>
        <p>Sie haben im Rahmen der gesetzlichen Vorgaben insbesondere folgende Rechte:</p>
        <ul>
          <li>Auskunft über die bei uns gespeicherten personenbezogenen Daten,</li>
          <li>Berichtigung unrichtiger oder Vervollständigung unvollständiger Daten,</li>
          <li>Löschung Ihrer Daten, soweit keine Aufbewahrungspflichten entgegenstehen,</li>
          <li>Einschränkung der Verarbeitung,</li>
          <li>Widerspruch gegen eine Verarbeitung auf Grundlage berechtigter Interessen,</li>
          <li>Datenübertragbarkeit, soweit die gesetzlichen Voraussetzungen vorliegen,</li>
          <li>Widerruf erteilter Einwilligungen mit Wirkung für die Zukunft.</li>
        </ul>

        <h2>10. Beschwerderecht</h2>
        <p>
          Sie haben das Recht, sich bei einer Datenschutz-Aufsichtsbehörde zu beschweren, wenn Sie
          der Ansicht sind, dass die Verarbeitung Ihrer personenbezogenen Daten gegen geltendes
          Datenschutzrecht verstößt.
        </p>
      </div>
    </div>
  );
};

export default DatenschutzPage;
